import config from 'constants/config'
import { isEnabledForFeature } from 'lib/config/featureFlagUtils'
import { parseSearchString } from 'lib/url/searchUrlUtils'
import createSelector from 'lib/web/createSelector'
import { isLEStaff } from 'selectors/accountSelectors'

export const isTripPlannerEnabled = createSelector(
  (state: App.State) => state.geo.currentRegionCode,
  (regionCode) =>
    isEnabledForFeature(config.TRIP_PLANNER_REGIONS, regionCode) &&
    config.ENABLE_TRIP_PLANNER,
)

export const getImmersiveTripId = (state: App.State) =>
  state.tripPlanner.currentTripId

export const selectTripPlannerTemplateId = createSelector(
  (state: App.State) => state.router.location.search,
  (search): string => {
    const params = parseSearchString(search)
    return params.templateId
  },
)

export const selectTripPlannerTemplateItemId = createSelector(
  (state: App.State) => state.router.location.search,
  (search): string => {
    const params = parseSearchString(search)
    return params.templateItemId
  },
)

const userTestingEmail = 'tripplanner_test@luxuryescapes.com'

export const isExploreEnabled = (state: App.State) =>
  config.TRIP_PLANNER_ENABLE_EXPLORE_FOR_ALL_USERS ||
  isLEStaff(state) ||
  state.auth.account.email === userTestingEmail
